import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import 'dayjs/locale/en';

export function dateToReadableShowDate(date: Date, locale = 'nl'): string {
  return dayjs(date).locale(locale).format('dddd D MMMM YYYY');
}

export function dateToReadableDay(date: Date | string, locale = 'nl'): string {
  return dayjs(date).locale(locale).format('D MMMM YYYY');
}

export function dateToInputDate(date: Date | string): string {
  return dayjs(date).format('YYYY-MM-DD');
}

export function dateToDutchInputDate(date: Date | string | undefined): string {
  return dayjs(date).format('DD-MM-YYYY');
}

export function dateToTime(date: Date | string | undefined): string {
  return date ? dayjs(date).format('HH:mm') : '';
}

export function dateToReadableDayAndTime(
  date: Date | string,
  locale = 'nl'
): string {
  return dayjs(date).locale(locale).format('D MMMM YYYY HH:mm');
}
